import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllShowIdentityType = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [allLabelTypes, setAllLabelTypes] = useState([]);

  const GetAllShowIdentityType = () => {
    setLoading(true);
    axiosClient
      .get(`Product/Branch/Packaging/Print/GetAllShowIdentityType`)
      .then(res => {
        if (res.status === 200) {
          // enqueueSnackbar(res.data?.message, { variant: 'success' });
          setAllLabelTypes(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [GetAllShowIdentityType, loading, allLabelTypes];
};

export default useGetAllShowIdentityType;
